// ============================================================================
// Catálogos de productos — UI strings (es / en / ca).
//
// Kept in its own module (merged into the main bundles by lib/i18n.js) so the
// feature's ~250 strings don't have to be threaded through the three large
// locale JSON files. Pakistani accounts render English (see Layout).
// ============================================================================

const es = {
  catalogue: {
    title: 'Catálogos',
    create: 'Crear catálogo',
    newTitle: 'Nuevo catálogo',
    untitled: 'Catálogo sin nombre',
    backToProducts: 'Volver a Productos',
    backToList: 'Volver a Catálogos',
    loading: 'Cargando…',
    retry: 'Reintentar',
    cancel: 'Cancelar',
    actions: 'Acciones',
    searchPlaceholder: 'Buscar catálogos…',
    filterAll: 'Todos',
    filterRecent: 'Actualizados recientemente',
    noMatches: 'Nada coincide con la búsqueda.',
    emptyTitle: 'Aún no hay catálogos',
    emptyBody: 'Crea un catálogo profesional a partir de tus productos.',
    colName: 'Catálogo',
    colProducts: 'Productos',
    colStatus: 'Estado',
    colUpdated: 'Actualizado',
    colCreated: 'Creado',
    status_draft: 'Borrador',
    status_published: 'Publicado',
    status_unpublished: 'Despublicado',
    views: 'Visitas del enlace público',
    viewCount_one: '{{count}} visita',
    viewCount_other: '{{count}} visitas',
    openEdit: 'Abrir / editar',
    edit: 'Editar',
    preview: 'Vista previa',
    duplicate: 'Duplicar',
    copySuffix: '(copia)',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    openPublic: 'Abrir enlace público',
    open: 'Abrir',
    downloadPdf: 'Descargar PDF',
    pdfProgress: 'PDF {{done}}/{{total}}…',
    print: 'Imprimir',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar catálogo',
    deleteBody: 'Se eliminará «{{name}}» y su enlace público dejará de funcionar. Los productos no se tocan.',
    deleted: 'Catálogo «{{name}}» eliminado.',
    duplicated: 'Catálogo «{{name}}» duplicado como borrador.',
    publishedOk: 'Catálogo publicado correctamente.',
    unpublishedOk: 'Catálogo despublicado: el enlace público ya no lo muestra.',
    savedOk: 'Catálogo guardado.',
    createdOk: 'Catálogo creado correctamente.',
    errLoadList: 'No se han podido cargar los catálogos.',
    errLoadOne: 'No se ha podido cargar el catálogo.',
    errLoadProducts: 'No se han podido cargar los productos.',
    errSave: 'No se ha podido guardar el catálogo.',
    errDelete: 'No se ha podido eliminar el catálogo.',
    errDuplicate: 'No se ha podido duplicar el catálogo.',
    errPublish: 'No se ha podido cambiar la publicación del catálogo.',
    errPdf: 'No se ha podido generar el PDF. Inténtalo de nuevo.',
    errPrint: 'No se ha podido preparar la impresión.',
    errDefaults: 'No se han podido guardar los valores por defecto.',
    errImageType: 'El archivo debe ser una imagen PNG, JPG, WEBP o GIF.',
    errImageTooLarge: 'La imagen supera los 5 MB.',
    errImageUpload: 'No se ha podido subir la imagen.',
    notFound: 'Este catálogo no existe o no tienes acceso.',
    schemaMissingTitle: 'Módulo pendiente de activar',
    schemaMissingBody: 'La base de datos aún no tiene las tablas de catálogos (backend/product_catalogues.sql). Contacta con el administrador.',
    steps: 'Pasos',
    stepOf: 'Paso {{n}} de {{total}}',
    step_products: 'Productos',
    step_template: 'Plantilla',
    step_customize: 'Personalizar',
    step_preview: 'Vista previa',
    step_save: 'Guardar',
    back: 'Atrás',
    continue: 'Continuar',
    unsaved: 'Cambios sin guardar',
    review: 'Revisar',
    name: 'Nombre del catálogo',
    namePlaceholder: 'p. ej. Catálogo de verano 2026',
    description: 'Descripción',
    descriptionPlaceholder: 'Opcional: aparece en la portada y en el enlace público',
    template: 'Plantilla',
    pages: 'Páginas',
    // Product selection
    searchProducts: 'Buscar por nombre, código o descripción…',
    allCategories: 'Todas las familias',
    allBrands: 'Todas las marcas',
    stockAll: 'Cualquier stock',
    inStock: 'En stock',
    outOfStock: 'Sin stock',
    sortName: 'Nombre (A-Z)',
    sortCategory: 'Familia',
    sortSku: 'Código',
    sortPriceAsc: 'Precio ↑',
    sortPriceDesc: 'Precio ↓',
    sortSelected: 'Ordenar',
    priceRange: 'Precio',
    min: 'mín.',
    max: 'máx.',
    matching_one: '{{count}} producto',
    matching_other: '{{count}} productos',
    selectAllFiltered: 'Seleccionar todos',
    deselectFiltered: 'Quitar todos',
    prev: 'Anterior',
    next: 'Siguiente',
    selectedCount_one: '{{count}} producto seleccionado',
    selectedCount_other: '{{count}} productos seleccionados',
    clear: 'Vaciar',
    reorderHint: 'Arrastra para reordenar, usa las flechas o escribe la posición.',
    position: 'Posición',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    remove: 'Quitar',
    replace: 'Sustituir',
    replacePick: 'Elige en la lista el producto que ocupará ese lugar.',
    deletedProduct: 'Producto eliminado',
    noLongerAvailable: 'Ya no está disponible',
    unavailableWarning_one: '{{count}} producto de este catálogo ya no está disponible.',
    unavailableWarning_other: '{{count}} productos de este catálogo ya no están disponibles.',
    removeUnavailable: 'Quitarlos del catálogo',
    selectAtLeastOne: 'Selecciona al menos un producto para continuar.',
    noProductsTitle: 'No hay productos',
    noProductsBody: 'Añade productos primero y luego crea tu catálogo.',
    goToProducts: 'Ir a Productos',
    skuShort: 'Ref.',
    // Templates
    tpl_grid: 'Cuadrícula',
    tpl_grid_desc: 'De 2 a 4 productos por fila, con foto, nombre y precio.',
    tpl_list: 'Lista de productos',
    tpl_list_desc: 'Una fila por producto: foto, nombre, referencia, descripción y precio.',
    tpl_image: 'Catálogo de imágenes',
    tpl_image_desc: 'Fotos grandes: dos productos por página con su descripción.',
    tpl_price_list: 'Lista de precios',
    tpl_price_list_desc: 'Tabla compacta: producto, referencia y precio. Ideal para muchos artículos.',
    tpl_wholesale: 'Mayorista',
    tpl_wholesale_desc: 'Tabla con miniatura, referencia, unidad, precio y casilla de cantidad para pedidos.',
    // Customize
    livePreview: 'Vista previa en directo',
    previewFirstPages: 'Primeras {{shown}} de {{total}} páginas',
    showPreview: 'Ver vista previa',
    hidePreview: 'Ocultar vista previa',
    secPrices: 'Precios',
    priceDisplay: 'Mostrar precios',
    priceShow: 'Mostrar precio',
    priceHide: 'Ocultar precio',
    priceContact: '«Consultar precio»',
    priceList: 'Tarifa',
    priceListBase: 'Precio de venta (PVP)',
    priceListHint: 'Crea tarifas en Configuración › Tarifas para mostrar precios mayoristas o especiales.',
    taxMode: 'Impuestos',
    taxIncl: 'IVA incluido',
    taxExcl: 'Sin IVA',
    pricesInclTax: 'Precios con IVA incluido',
    pricesExclTax: 'Precios sin IVA',
    contactForPrice: 'Consultar precio',
    secFields: 'Datos del producto',
    fieldSku: 'Código / referencia',
    fieldDescription: 'Descripción',
    fieldCategory: 'Familia / categoría',
    fieldBrand: 'Marca',
    fieldUnit: 'Unidad',
    fieldStock: 'Disponibilidad (en stock / sin stock)',
    secBranding: 'Marca',
    showLogo: 'Mostrar logotipo',
    logo: 'Logotipo',
    uploadImage: 'Subir imagen',
    companyName: 'Nombre de la empresa',
    email: 'Email',
    phone: 'Teléfono',
    website: 'Web',
    address: 'Dirección',
    secStyle: 'Estilo',
    primaryColor: 'Color principal',
    secondaryColor: 'Color secundario',
    background: 'Fondo de página',
    font: 'Tipografía',
    headingSize: 'Tamaño de títulos',
    bodySize: 'Tamaño del texto',
    size_sm: 'Pequeño',
    size_md: 'Normal',
    size_lg: 'Grande',
    borderStyle: 'Bordes',
    border_none: 'Sin borde',
    border_square: 'Rectos',
    border_soft: 'Suaves',
    border_rounded: 'Redondeados',
    cardStyle: 'Tarjeta de producto',
    card_outline: 'Contorno',
    card_shadow: 'Sombra',
    card_flat: 'Plana',
    secLayout: 'Diseño de página',
    perRow: 'Productos por fila',
    orientation: 'Orientación',
    portrait: 'Vertical',
    landscape: 'Horizontal',
    pageSize: 'Tamaño de página',
    margins: 'Márgenes',
    margin_narrow: 'Estrechos',
    margin_normal: 'Normales',
    margin_wide: 'Anchos',
    imageRatio: 'Formato de imagen',
    ratio_square: 'Cuadrada',
    ratio_portrait: 'Vertical',
    ratio_landscape: 'Horizontal',
    secCover: 'Portada',
    coverEnabled: 'Incluir portada',
    coverTitle: 'Título',
    coverTitleHint: 'Si lo dejas vacío se usa el nombre del catálogo.',
    coverSubtitle: 'Subtítulo',
    coverYear: 'Fecha / año',
    coverImage: 'Imagen de portada',
    coverShowCount: 'Mostrar número de productos',
    coverShowContact: 'Mostrar datos de contacto',
    coverShowQr: 'Mostrar código QR del enlace público',
    qrAfterPublish: 'El código QR aparece cuando el catálogo está publicado.',
    secFooter: 'Pie de página',
    footerText: 'Texto del pie',
    terms: 'Condiciones / notas',
    termsHint: 'Se imprimen en una página final y al pie del enlace público.',
    termsTitle: 'Condiciones',
    footerContact: 'Teléfono y email en el pie',
    footerWebsite: 'Web en el pie',
    pageNumbers: 'Números de página',
    footerQr: 'Código QR pequeño en cada página',
    secPublic: 'Enlace público',
    quoteRequests: 'Permitir pedir presupuesto',
    quoteRequestsHint: 'Los visitantes marcan productos y cantidades y te envían la solicitud: llega a Catálogos › Solicitudes y la conviertes en presupuesto con un clic. También pueden mandarla por email o WhatsApp (con el email y teléfono de «Marca»).',
    saveAsDefault: 'Usar este estilo por defecto en catálogos nuevos',
    defaultsSaved: 'Estilo guardado como predeterminado para nuevos catálogos.',
    // Preview
    previewPrint: 'Impresión / PDF',
    previewWeb: 'Web',
    previewMobile: 'Móvil',
    pageOf: 'Página {{page}} / {{total}}',
    noProductsSelected: 'No hay productos seleccionados',
    productCount_one: '{{count}} producto',
    productCount_other: '{{count}} productos',
    perUnit: 'por {{unit}}',
    colProduct: 'Producto',
    colSku: 'Referencia',
    colCategory: 'Familia',
    colUnit: 'Unidad',
    colStock: 'Stock',
    colPrice: 'Precio',
    colQty: 'Cantidad',
    scanToView: 'Escanea para ver el catálogo en línea',
    pdfOutdated: 'La información de productos ha cambiado desde el PDF generado el {{date}}.',
    // Save
    saveDraft: 'Guardar borrador',
    saveChanges: 'Guardar cambios',
    saveAndPublish: 'Guardar y publicar',
    successSaved: 'Catálogo guardado correctamente.',
    successPublished: 'Catálogo publicado: ya está disponible en su enlace público.',
    viewCatalogue: 'Ver catálogo',
    publicLink: 'Enlace público',
    slugChangeWarning: 'Si cambias el enlace de un catálogo publicado, el anterior (y sus QR impresos) dejará de funcionar.',
    publicDraftHint: 'El enlace sólo funcionará cuando publiques el catálogo.',
    publicLiveHint: 'Cualquiera con el enlace puede ver este catálogo. Los precios de coste, proveedores y notas internas nunca se muestran.',
    noEditPermission: 'No tienes permiso para modificar catálogos.',
    // QR
    qrTitle: 'Código QR del catálogo',
    qrCode: 'Código QR',
    copyLink: 'Copiar enlace',
    downloadQr: 'Descargar QR',
    printQr: 'Imprimir QR',
    qrError: 'No se ha podido descargar el código QR.',
    popupBlocked: 'El navegador ha bloqueado la ventana de impresión. Permite ventanas emergentes e inténtalo de nuevo.',
    // Products integration
    addToCatalogue: 'Añadir a catálogo',
    addToCatalogueBody_one: 'Elige un catálogo para añadir este producto o crea uno nuevo.',
    addToCatalogueBody_other: 'Elige un catálogo para añadir {{count}} productos o crea uno nuevo.',
    includedIn_one: 'Incluido en {{count}} catálogo.',
    includedIn_other: 'Incluido en {{count}} catálogos.',
    included: 'Incluido',
    add: 'Añadir',
    addedTo_one: '{{count}} producto añadido a «{{name}}».',
    addedTo_other: '{{count}} productos añadidos a «{{name}}».',
    alreadyIn: 'Ya estaban en «{{name}}».',
    createWithProducts_one: 'Nuevo catálogo con este producto',
    createWithProducts_other: 'Nuevo catálogo con {{count}} productos',
    // Public page
    publicNotFound: 'Catálogo no disponible',
    publicNotFoundBody: 'El enlace no es válido o el catálogo ya no está publicado.',
    publicError: 'No se ha podido cargar el catálogo',
    publicErrorBody: 'Comprueba tu conexión e inténtalo de nuevo.',
    publicEmpty: 'Este catálogo no tiene productos disponibles en este momento.',
    metaDescription: '{{name}}: catálogo con {{count}} productos.',
    addToQuote: 'Añadir al presupuesto',
    less: 'Menos',
    more: 'Más',
    quoteSummary_one: '{{count}} producto · {{units}} uds.',
    quoteSummary_other: '{{count}} productos · {{units}} uds.',
    requestQuote: 'Pedir presupuesto',
    yourName: 'Tu nombre o empresa (opcional)',
    sendByEmail: 'Email',
    sendByWhatsapp: 'WhatsApp',
    clearQuote: 'Vaciar selección',
    quoteSubject: 'Solicitud de presupuesto — {{name}}',
    quoteIntro: 'Hola, me gustaría recibir un presupuesto de estos productos:',
    quoteIntroNamed: 'Hola, soy {{name}} y me gustaría recibir un presupuesto de estos productos:',
    // Quote requests (in-app)
    yourEmail: 'Email',
    yourPhone: 'Teléfono',
    yourMessage: 'Mensaje (opcional)',
    contactHint: 'Indica al menos un email o un teléfono para que puedan responderte.',
    sendRequest: 'Enviar solicitud',
    orSendBy: 'o envíala tú mismo por',
    quoteSentTitle: 'Solicitud enviada',
    quoteSentBody: '{{company}} ha recibido tu solicitud y te contactará con el presupuesto.',
    backToCatalogue: 'Volver al catálogo',
    quoteErr: {
      contact_required: 'Indica un email o un teléfono.',
      email_invalid: 'El email no es válido.',
      phone_invalid: 'El teléfono no es válido.',
      items_invalid: 'Los productos elegidos ya no están disponibles. Recarga la página.',
      rate_limited: 'Se han enviado demasiadas solicitudes. Vuelve a intentarlo dentro de un rato.',
      quote_requests_off: 'Este catálogo no acepta solicitudes de presupuesto.',
      catalogue_not_available: 'Este catálogo ya no está disponible.',
      failed: 'No se ha podido enviar la solicitud. Inténtalo de nuevo.',
    },
    tabCatalogues: 'Catálogos',
    tabRequests: 'Solicitudes',
    newRequests_one: '{{count}} solicitud de presupuesto pendiente',
    newRequests_other: '{{count}} solicitudes de presupuesto pendientes',
    errLoadRequests: 'No se han podido cargar las solicitudes.',
    req_new: 'Pendientes',
    req_done: 'Atendidas',
    req_dismissed: 'Descartadas',
    req_all: 'Todas',
    noRequestsTitle: 'No hay solicitudes',
    noRequestsBody: 'Cuando alguien pida un presupuesto desde un catálogo publicado, aparecerá aquí.',
    requestSummary_one: '{{count}} producto · {{units}} uds.',
    requestSummary_other: '{{count}} productos · {{units}} uds.',
    createEstimate: 'Crear presupuesto',
    openEstimate: 'Abrir presupuesto',
    markDone: 'Marcar como atendida',
    dismiss: 'Descartar',
    reopen: 'Reabrir',
    estimateFromRequest: 'Solicitud del catálogo «{{catalogue}}».',
    err: {
      nameRequired: 'El nombre del catálogo es obligatorio.',
      nameTooLong: 'El nombre no puede superar 120 caracteres.',
      slugInvalid: 'El enlace sólo admite minúsculas, números y guiones (3-80 caracteres).',
      slugTaken: 'Ese enlace ya lo usa otro catálogo. Elige otro.',
      duplicateProducts: 'Hay productos repetidos en el catálogo.',
      noProducts: 'Un catálogo necesita al menos un producto para publicarse.',
      selectAtLeastOne: 'Selecciona al menos un producto para continuar.',
    },
  },
  perms: {
    mod_catalogue: 'Catálogos de productos',
    'p_catalogue.view': 'Ver catálogos',
    'p_catalogue.create': 'Crear catálogos',
    'p_catalogue.edit': 'Editar catálogos',
    'p_catalogue.delete': 'Eliminar catálogos',
    'p_catalogue.publish': 'Publicar / despublicar catálogos',
  },
};

const en = {
  catalogue: {
    title: 'Catalogues',
    create: 'Create Catalogue',
    newTitle: 'New catalogue',
    untitled: 'Untitled catalogue',
    backToProducts: 'Back to Products',
    backToList: 'Back to Catalogues',
    loading: 'Loading…',
    retry: 'Try again',
    cancel: 'Cancel',
    actions: 'Actions',
    searchPlaceholder: 'Search catalogues…',
    filterAll: 'All',
    filterRecent: 'Recently updated',
    noMatches: 'Nothing matches your search.',
    emptyTitle: 'No catalogues yet',
    emptyBody: 'Create a professional catalogue from your existing products.',
    colName: 'Catalogue',
    colProducts: 'Products',
    colStatus: 'Status',
    colUpdated: 'Updated',
    colCreated: 'Created',
    status_draft: 'Draft',
    status_published: 'Published',
    status_unpublished: 'Unpublished',
    views: 'Public link views',
    viewCount_one: '{{count}} view',
    viewCount_other: '{{count}} views',
    openEdit: 'Open / edit',
    edit: 'Edit',
    preview: 'Preview',
    duplicate: 'Duplicate',
    copySuffix: '(copy)',
    publish: 'Publish',
    unpublish: 'Unpublish',
    openPublic: 'Open public link',
    open: 'Open',
    downloadPdf: 'Download PDF',
    pdfProgress: 'PDF {{done}}/{{total}}…',
    print: 'Print',
    delete: 'Delete',
    deleteTitle: 'Delete catalogue',
    deleteBody: '"{{name}}" will be deleted and its public link will stop working. Your products are not affected.',
    deleted: 'Catalogue "{{name}}" deleted.',
    duplicated: 'Catalogue "{{name}}" duplicated as a draft.',
    publishedOk: 'Catalogue published successfully.',
    unpublishedOk: 'Catalogue unpublished: the public link no longer shows it.',
    savedOk: 'Catalogue saved.',
    createdOk: 'Catalogue created successfully.',
    errLoadList: 'Unable to load catalogues.',
    errLoadOne: 'Unable to load the catalogue.',
    errLoadProducts: 'Unable to load products.',
    errSave: 'Unable to save catalogue.',
    errDelete: 'Unable to delete the catalogue.',
    errDuplicate: 'Unable to duplicate the catalogue.',
    errPublish: 'Unable to change the catalogue\'s publication.',
    errPdf: 'PDF generation failed. Please try again.',
    errPrint: 'Unable to prepare printing.',
    errDefaults: 'Unable to save the defaults.',
    errImageType: 'The file must be a PNG, JPG, WEBP or GIF image.',
    errImageTooLarge: 'The image is larger than 5 MB.',
    errImageUpload: 'Unable to upload the image.',
    notFound: 'This catalogue does not exist or you do not have access to it.',
    schemaMissingTitle: 'Module not set up yet',
    schemaMissingBody: 'The database does not have the catalogue tables yet (backend/product_catalogues.sql). Please contact the administrator.',
    steps: 'Steps',
    stepOf: 'Step {{n}} of {{total}}',
    step_products: 'Products',
    step_template: 'Template',
    step_customize: 'Customize',
    step_preview: 'Preview',
    step_save: 'Save',
    back: 'Back',
    continue: 'Continue',
    unsaved: 'Unsaved changes',
    review: 'Review',
    name: 'Catalogue name',
    namePlaceholder: 'e.g. Summer Catalogue 2026',
    description: 'Description',
    descriptionPlaceholder: 'Optional: shown on the cover and the public link',
    template: 'Template',
    pages: 'Pages',
    searchProducts: 'Search by name, code or description…',
    allCategories: 'All categories',
    allBrands: 'All brands',
    stockAll: 'Any stock',
    inStock: 'In stock',
    outOfStock: 'Out of stock',
    sortName: 'Name (A-Z)',
    sortCategory: 'Category',
    sortSku: 'SKU',
    sortPriceAsc: 'Price ↑',
    sortPriceDesc: 'Price ↓',
    sortSelected: 'Sort',
    priceRange: 'Price',
    min: 'min',
    max: 'max',
    matching_one: '{{count}} product',
    matching_other: '{{count}} products',
    selectAllFiltered: 'Select all',
    deselectFiltered: 'Deselect all',
    prev: 'Previous',
    next: 'Next',
    selectedCount_one: '{{count}} product selected',
    selectedCount_other: '{{count}} products selected',
    clear: 'Clear',
    reorderHint: 'Drag to reorder, use the arrows or type a position.',
    position: 'Position',
    moveUp: 'Move up',
    moveDown: 'Move down',
    remove: 'Remove',
    replace: 'Replace',
    replacePick: 'Pick the product that will take its place from the list.',
    deletedProduct: 'Deleted product',
    noLongerAvailable: 'No longer available',
    unavailableWarning_one: '{{count}} product in this catalogue is no longer available.',
    unavailableWarning_other: '{{count}} products in this catalogue are no longer available.',
    removeUnavailable: 'Remove them from the catalogue',
    selectAtLeastOne: 'Select at least one product to continue.',
    noProductsTitle: 'No products available',
    noProductsBody: 'Add products first, then create your catalogue.',
    goToProducts: 'Go to Products',
    skuShort: 'SKU',
    tpl_grid: 'Grid',
    tpl_grid_desc: '2 to 4 products per row, with photo, name and price.',
    tpl_list: 'Product list',
    tpl_list_desc: 'One row per product: photo, name, SKU, description and price.',
    tpl_image: 'Image catalogue',
    tpl_image_desc: 'Large photos: two products per page with their description.',
    tpl_price_list: 'Price list',
    tpl_price_list_desc: 'Compact table: product, SKU and price. Best for many items.',
    tpl_wholesale: 'Wholesale',
    tpl_wholesale_desc: 'Table with thumbnail, SKU, unit, price and a quantity box for orders.',
    livePreview: 'Live preview',
    previewFirstPages: 'First {{shown}} of {{total}} pages',
    showPreview: 'Show preview',
    hidePreview: 'Hide preview',
    secPrices: 'Prices',
    priceDisplay: 'Price display',
    priceShow: 'Show price',
    priceHide: 'Hide price',
    priceContact: '"Contact us for price"',
    priceList: 'Price list',
    priceListBase: 'Selling price',
    priceListHint: 'Create price lists in Settings › Tariffs to show wholesale or special prices.',
    taxMode: 'Tax',
    taxIncl: 'Tax included',
    taxExcl: 'Excluding tax',
    pricesInclTax: 'Prices include tax',
    pricesExclTax: 'Prices exclude tax',
    contactForPrice: 'Contact us for price',
    secFields: 'Product information',
    fieldSku: 'SKU / code',
    fieldDescription: 'Description',
    fieldCategory: 'Category',
    fieldBrand: 'Brand',
    fieldUnit: 'Unit',
    fieldStock: 'Availability (in / out of stock)',
    secBranding: 'Branding',
    showLogo: 'Show logo',
    logo: 'Logo',
    uploadImage: 'Upload image',
    companyName: 'Company name',
    email: 'Email',
    phone: 'Phone',
    website: 'Website',
    address: 'Address',
    secStyle: 'Style',
    primaryColor: 'Primary colour',
    secondaryColor: 'Secondary colour',
    background: 'Page background',
    font: 'Font',
    headingSize: 'Heading size',
    bodySize: 'Body size',
    size_sm: 'Small',
    size_md: 'Normal',
    size_lg: 'Large',
    borderStyle: 'Borders',
    border_none: 'None',
    border_square: 'Square',
    border_soft: 'Soft',
    border_rounded: 'Rounded',
    cardStyle: 'Product card',
    card_outline: 'Outline',
    card_shadow: 'Shadow',
    card_flat: 'Flat',
    secLayout: 'Page layout',
    perRow: 'Products per row',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    pageSize: 'Page size',
    margins: 'Margins',
    margin_narrow: 'Narrow',
    margin_normal: 'Normal',
    margin_wide: 'Wide',
    imageRatio: 'Image ratio',
    ratio_square: 'Square',
    ratio_portrait: 'Portrait',
    ratio_landscape: 'Landscape',
    secCover: 'Cover',
    coverEnabled: 'Include a cover',
    coverTitle: 'Title',
    coverTitleHint: 'Leave empty to use the catalogue name.',
    coverSubtitle: 'Subtitle',
    coverYear: 'Date / year',
    coverImage: 'Cover image',
    coverShowCount: 'Show number of products',
    coverShowContact: 'Show contact details',
    coverShowQr: 'Show QR code of the public link',
    qrAfterPublish: 'The QR code appears once the catalogue is published.',
    secFooter: 'Footer',
    footerText: 'Footer text',
    terms: 'Terms / notes',
    termsHint: 'Printed on a final page and at the bottom of the public link.',
    termsTitle: 'Terms',
    footerContact: 'Phone and email in the footer',
    footerWebsite: 'Website in the footer',
    pageNumbers: 'Page numbers',
    footerQr: 'Small QR code on every page',
    secPublic: 'Public link',
    quoteRequests: 'Allow quote requests',
    quoteRequestsHint: 'Visitors tick products and quantities and send you the request: it arrives in Catalogues › Quote requests and becomes a quote in one click. They can also send it by email or WhatsApp (using the email and phone from "Branding").',
    saveAsDefault: 'Use this style by default for new catalogues',
    defaultsSaved: 'Style saved as the default for new catalogues.',
    previewPrint: 'Print / PDF',
    previewWeb: 'Web',
    previewMobile: 'Mobile',
    pageOf: 'Page {{page}} / {{total}}',
    noProductsSelected: 'No products selected',
    productCount_one: '{{count}} product',
    productCount_other: '{{count}} products',
    perUnit: 'per {{unit}}',
    colProduct: 'Product',
    colSku: 'SKU',
    colCategory: 'Category',
    colUnit: 'Unit',
    colStock: 'Stock',
    colPrice: 'Price',
    colQty: 'Qty',
    scanToView: 'Scan to view the catalogue online',
    pdfOutdated: 'Product information updated since the PDF generated on {{date}}.',
    saveDraft: 'Save draft',
    saveChanges: 'Save changes',
    saveAndPublish: 'Save and publish',
    successSaved: 'Catalogue saved successfully.',
    successPublished: 'Catalogue published: it is now live at its public link.',
    viewCatalogue: 'View Catalogue',
    publicLink: 'Public link',
    slugChangeWarning: 'Changing the link of a published catalogue breaks the old link (and any printed QR codes).',
    publicDraftHint: 'The link only works once you publish the catalogue.',
    publicLiveHint: 'Anyone with the link can view this catalogue. Cost prices, suppliers and internal notes are never shown.',
    noEditPermission: 'You do not have permission to change catalogues.',
    qrTitle: 'Catalogue QR code',
    qrCode: 'QR code',
    copyLink: 'Copy link',
    downloadQr: 'Download QR Code',
    printQr: 'Print QR Code',
    qrError: 'Unable to download the QR code.',
    popupBlocked: 'The browser blocked the print window. Allow pop-ups and try again.',
    addToCatalogue: 'Add to Catalogue',
    addToCatalogueBody_one: 'Choose a catalogue to add this product to, or create a new one.',
    addToCatalogueBody_other: 'Choose a catalogue to add {{count}} products to, or create a new one.',
    includedIn_one: 'Included in {{count}} catalogue.',
    includedIn_other: 'Included in {{count}} catalogues.',
    included: 'Included',
    add: 'Add',
    addedTo_one: '{{count}} product added to "{{name}}".',
    addedTo_other: '{{count}} products added to "{{name}}".',
    alreadyIn: 'They were already in "{{name}}".',
    createWithProducts_one: 'New catalogue with this product',
    createWithProducts_other: 'New catalogue with {{count}} products',
    publicNotFound: 'Catalogue not available',
    publicNotFoundBody: 'The link is not valid or the catalogue is no longer published.',
    publicError: 'Unable to load the catalogue',
    publicErrorBody: 'Check your connection and try again.',
    publicEmpty: 'This catalogue has no products available right now.',
    metaDescription: '{{name}}: catalogue with {{count}} products.',
    addToQuote: 'Add to quote',
    less: 'Less',
    more: 'More',
    quoteSummary_one: '{{count}} product · {{units}} units',
    quoteSummary_other: '{{count}} products · {{units}} units',
    requestQuote: 'Request Quote',
    yourName: 'Your name or company (optional)',
    sendByEmail: 'Email',
    sendByWhatsapp: 'WhatsApp',
    clearQuote: 'Clear selection',
    quoteSubject: 'Quote request — {{name}}',
    quoteIntro: 'Hello, I would like a quote for these products:',
    quoteIntroNamed: 'Hello, this is {{name}}. I would like a quote for these products:',
    // Quote requests (in-app)
    yourEmail: 'Email',
    yourPhone: 'Phone',
    yourMessage: 'Message (optional)',
    contactHint: 'Give at least an email or a phone number so they can reply.',
    sendRequest: 'Send request',
    orSendBy: 'or send it yourself by',
    quoteSentTitle: 'Request sent',
    quoteSentBody: '{{company}} has received your request and will get back to you with a quote.',
    backToCatalogue: 'Back to the catalogue',
    quoteErr: {
      contact_required: 'Enter an email or a phone number.',
      email_invalid: 'The email is not valid.',
      phone_invalid: 'The phone number is not valid.',
      items_invalid: 'The chosen products are no longer available. Reload the page.',
      rate_limited: 'Too many requests were sent. Please try again later.',
      quote_requests_off: 'This catalogue does not accept quote requests.',
      catalogue_not_available: 'This catalogue is no longer available.',
      failed: 'Unable to send the request. Please try again.',
    },
    tabCatalogues: 'Catalogues',
    tabRequests: 'Quote requests',
    newRequests_one: '{{count}} quote request waiting',
    newRequests_other: '{{count}} quote requests waiting',
    errLoadRequests: 'Unable to load quote requests.',
    req_new: 'Waiting',
    req_done: 'Answered',
    req_dismissed: 'Dismissed',
    req_all: 'All',
    noRequestsTitle: 'No quote requests',
    noRequestsBody: 'When someone asks for a quote from a published catalogue, it shows up here.',
    requestSummary_one: '{{count}} product · {{units}} units',
    requestSummary_other: '{{count}} products · {{units}} units',
    createEstimate: 'Create quote',
    openEstimate: 'Open quote',
    markDone: 'Mark as answered',
    dismiss: 'Dismiss',
    reopen: 'Reopen',
    estimateFromRequest: 'Request from the catalogue "{{catalogue}}".',
    err: {
      nameRequired: 'Catalogue name is required.',
      nameTooLong: 'The name cannot be longer than 120 characters.',
      slugInvalid: 'The link can only contain lowercase letters, numbers and hyphens (3-80 characters).',
      slugTaken: 'That link is already used by another catalogue. Choose another.',
      duplicateProducts: 'Some products appear twice in the catalogue.',
      noProducts: 'A catalogue needs at least one product before it can be published.',
      selectAtLeastOne: 'Select at least one product to continue.',
    },
  },
  perms: {
    mod_catalogue: 'Product catalogues',
    'p_catalogue.view': 'View catalogues',
    'p_catalogue.create': 'Create catalogues',
    'p_catalogue.edit': 'Edit catalogues',
    'p_catalogue.delete': 'Delete catalogues',
    'p_catalogue.publish': 'Publish / unpublish catalogues',
  },
};

const ca = {
  catalogue: {
    title: 'Catàlegs',
    create: 'Crear catàleg',
    newTitle: 'Nou catàleg',
    untitled: 'Catàleg sense nom',
    backToProducts: 'Tornar a Productes',
    backToList: 'Tornar a Catàlegs',
    loading: 'Carregant…',
    retry: 'Tornar-ho a provar',
    cancel: 'Cancel·lar',
    actions: 'Accions',
    searchPlaceholder: 'Cercar catàlegs…',
    filterAll: 'Tots',
    filterRecent: 'Actualitzats recentment',
    noMatches: 'Res no coincideix amb la cerca.',
    emptyTitle: 'Encara no hi ha catàlegs',
    emptyBody: 'Crea un catàleg professional a partir dels teus productes.',
    colName: 'Catàleg',
    colProducts: 'Productes',
    colStatus: 'Estat',
    colUpdated: 'Actualitzat',
    colCreated: 'Creat',
    status_draft: 'Esborrany',
    status_published: 'Publicat',
    status_unpublished: 'Despublicat',
    views: 'Visites de l\'enllaç públic',
    viewCount_one: '{{count}} visita',
    viewCount_other: '{{count}} visites',
    openEdit: 'Obrir / editar',
    edit: 'Editar',
    preview: 'Previsualització',
    duplicate: 'Duplicar',
    copySuffix: '(còpia)',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    openPublic: 'Obrir l\'enllaç públic',
    open: 'Obrir',
    downloadPdf: 'Descarregar PDF',
    pdfProgress: 'PDF {{done}}/{{total}}…',
    print: 'Imprimir',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar catàleg',
    deleteBody: 'S\'eliminarà «{{name}}» i el seu enllaç públic deixarà de funcionar. Els productes no es toquen.',
    deleted: 'Catàleg «{{name}}» eliminat.',
    duplicated: 'Catàleg «{{name}}» duplicat com a esborrany.',
    publishedOk: 'Catàleg publicat correctament.',
    unpublishedOk: 'Catàleg despublicat: l\'enllaç públic ja no el mostra.',
    savedOk: 'Catàleg desat.',
    createdOk: 'Catàleg creat correctament.',
    errLoadList: 'No s\'han pogut carregar els catàlegs.',
    errLoadOne: 'No s\'ha pogut carregar el catàleg.',
    errLoadProducts: 'No s\'han pogut carregar els productes.',
    errSave: 'No s\'ha pogut desar el catàleg.',
    errDelete: 'No s\'ha pogut eliminar el catàleg.',
    errDuplicate: 'No s\'ha pogut duplicar el catàleg.',
    errPublish: 'No s\'ha pogut canviar la publicació del catàleg.',
    errPdf: 'No s\'ha pogut generar el PDF. Torna-ho a provar.',
    errPrint: 'No s\'ha pogut preparar la impressió.',
    errDefaults: 'No s\'han pogut desar els valors per defecte.',
    errImageType: 'El fitxer ha de ser una imatge PNG, JPG, WEBP o GIF.',
    errImageTooLarge: 'La imatge supera els 5 MB.',
    errImageUpload: 'No s\'ha pogut pujar la imatge.',
    notFound: 'Aquest catàleg no existeix o no hi tens accés.',
    schemaMissingTitle: 'Mòdul pendent d\'activar',
    schemaMissingBody: 'La base de dades encara no té les taules de catàlegs (backend/product_catalogues.sql). Contacta amb l\'administrador.',
    steps: 'Passos',
    stepOf: 'Pas {{n}} de {{total}}',
    step_products: 'Productes',
    step_template: 'Plantilla',
    step_customize: 'Personalitzar',
    step_preview: 'Previsualització',
    step_save: 'Desar',
    back: 'Enrere',
    continue: 'Continuar',
    unsaved: 'Canvis sense desar',
    review: 'Revisar',
    name: 'Nom del catàleg',
    namePlaceholder: 'p. ex. Catàleg d\'estiu 2026',
    description: 'Descripció',
    descriptionPlaceholder: 'Opcional: apareix a la portada i a l\'enllaç públic',
    template: 'Plantilla',
    pages: 'Pàgines',
    searchProducts: 'Cercar per nom, codi o descripció…',
    allCategories: 'Totes les famílies',
    allBrands: 'Totes les marques',
    stockAll: 'Qualsevol estoc',
    inStock: 'En estoc',
    outOfStock: 'Sense estoc',
    sortName: 'Nom (A-Z)',
    sortCategory: 'Família',
    sortSku: 'Codi',
    sortPriceAsc: 'Preu ↑',
    sortPriceDesc: 'Preu ↓',
    sortSelected: 'Ordenar',
    priceRange: 'Preu',
    min: 'mín.',
    max: 'màx.',
    matching_one: '{{count}} producte',
    matching_other: '{{count}} productes',
    selectAllFiltered: 'Seleccionar-los tots',
    deselectFiltered: 'Treure-los tots',
    prev: 'Anterior',
    next: 'Següent',
    selectedCount_one: '{{count}} producte seleccionat',
    selectedCount_other: '{{count}} productes seleccionats',
    clear: 'Buidar',
    reorderHint: 'Arrossega per reordenar, fes servir les fletxes o escriu la posició.',
    position: 'Posició',
    moveUp: 'Pujar',
    moveDown: 'Baixar',
    remove: 'Treure',
    replace: 'Substituir',
    replacePick: 'Tria a la llista el producte que ocuparà aquest lloc.',
    deletedProduct: 'Producte eliminat',
    noLongerAvailable: 'Ja no està disponible',
    unavailableWarning_one: '{{count}} producte d\'aquest catàleg ja no està disponible.',
    unavailableWarning_other: '{{count}} productes d\'aquest catàleg ja no estan disponibles.',
    removeUnavailable: 'Treure\'ls del catàleg',
    selectAtLeastOne: 'Selecciona almenys un producte per continuar.',
    noProductsTitle: 'No hi ha productes',
    noProductsBody: 'Afegeix productes primer i després crea el teu catàleg.',
    goToProducts: 'Anar a Productes',
    skuShort: 'Ref.',
    tpl_grid: 'Quadrícula',
    tpl_grid_desc: 'De 2 a 4 productes per fila, amb foto, nom i preu.',
    tpl_list: 'Llista de productes',
    tpl_list_desc: 'Una fila per producte: foto, nom, referència, descripció i preu.',
    tpl_image: 'Catàleg d\'imatges',
    tpl_image_desc: 'Fotos grans: dos productes per pàgina amb la seva descripció.',
    tpl_price_list: 'Llista de preus',
    tpl_price_list_desc: 'Taula compacta: producte, referència i preu. Ideal per a molts articles.',
    tpl_wholesale: 'Majorista',
    tpl_wholesale_desc: 'Taula amb miniatura, referència, unitat, preu i casella de quantitat per a comandes.',
    livePreview: 'Previsualització en directe',
    previewFirstPages: 'Primeres {{shown}} de {{total}} pàgines',
    showPreview: 'Veure la previsualització',
    hidePreview: 'Amagar la previsualització',
    secPrices: 'Preus',
    priceDisplay: 'Mostrar preus',
    priceShow: 'Mostrar preu',
    priceHide: 'Amagar preu',
    priceContact: '«Consultar preu»',
    priceList: 'Tarifa',
    priceListBase: 'Preu de venda (PVP)',
    priceListHint: 'Crea tarifes a Configuració › Tarifes per mostrar preus majoristes o especials.',
    taxMode: 'Impostos',
    taxIncl: 'IVA inclòs',
    taxExcl: 'Sense IVA',
    pricesInclTax: 'Preus amb IVA inclòs',
    pricesExclTax: 'Preus sense IVA',
    contactForPrice: 'Consultar preu',
    secFields: 'Dades del producte',
    fieldSku: 'Codi / referència',
    fieldDescription: 'Descripció',
    fieldCategory: 'Família / categoria',
    fieldBrand: 'Marca',
    fieldUnit: 'Unitat',
    fieldStock: 'Disponibilitat (en estoc / sense estoc)',
    secBranding: 'Marca',
    showLogo: 'Mostrar el logotip',
    logo: 'Logotip',
    uploadImage: 'Pujar imatge',
    companyName: 'Nom de l\'empresa',
    email: 'Correu electrònic',
    phone: 'Telèfon',
    website: 'Web',
    address: 'Adreça',
    secStyle: 'Estil',
    primaryColor: 'Color principal',
    secondaryColor: 'Color secundari',
    background: 'Fons de pàgina',
    font: 'Tipografia',
    headingSize: 'Mida dels títols',
    bodySize: 'Mida del text',
    size_sm: 'Petita',
    size_md: 'Normal',
    size_lg: 'Gran',
    borderStyle: 'Vores',
    border_none: 'Sense vora',
    border_square: 'Rectes',
    border_soft: 'Suaus',
    border_rounded: 'Arrodonides',
    cardStyle: 'Targeta de producte',
    card_outline: 'Contorn',
    card_shadow: 'Ombra',
    card_flat: 'Plana',
    secLayout: 'Disseny de pàgina',
    perRow: 'Productes per fila',
    orientation: 'Orientació',
    portrait: 'Vertical',
    landscape: 'Horitzontal',
    pageSize: 'Mida de pàgina',
    margins: 'Marges',
    margin_narrow: 'Estrets',
    margin_normal: 'Normals',
    margin_wide: 'Amples',
    imageRatio: 'Format d\'imatge',
    ratio_square: 'Quadrada',
    ratio_portrait: 'Vertical',
    ratio_landscape: 'Horitzontal',
    secCover: 'Portada',
    coverEnabled: 'Incloure portada',
    coverTitle: 'Títol',
    coverTitleHint: 'Si el deixes buit es fa servir el nom del catàleg.',
    coverSubtitle: 'Subtítol',
    coverYear: 'Data / any',
    coverImage: 'Imatge de portada',
    coverShowCount: 'Mostrar el nombre de productes',
    coverShowContact: 'Mostrar les dades de contacte',
    coverShowQr: 'Mostrar el codi QR de l\'enllaç públic',
    qrAfterPublish: 'El codi QR apareix quan el catàleg està publicat.',
    secFooter: 'Peu de pàgina',
    footerText: 'Text del peu',
    terms: 'Condicions / notes',
    termsHint: 'S\'imprimeixen en una pàgina final i al peu de l\'enllaç públic.',
    termsTitle: 'Condicions',
    footerContact: 'Telèfon i correu al peu',
    footerWebsite: 'Web al peu',
    pageNumbers: 'Números de pàgina',
    footerQr: 'Codi QR petit a cada pàgina',
    secPublic: 'Enllaç públic',
    quoteRequests: 'Permetre demanar pressupost',
    quoteRequestsHint: 'Els visitants marquen productes i quantitats i t\'envien la sol·licitud: arriba a Catàlegs › Sol·licituds i la converteixes en pressupost amb un clic. També poden enviar-la per correu o WhatsApp (amb el correu i el telèfon de «Marca»).',
    saveAsDefault: 'Fer servir aquest estil per defecte als catàlegs nous',
    defaultsSaved: 'Estil desat com a predeterminat per als catàlegs nous.',
    previewPrint: 'Impressió / PDF',
    previewWeb: 'Web',
    previewMobile: 'Mòbil',
    pageOf: 'Pàgina {{page}} / {{total}}',
    noProductsSelected: 'No hi ha productes seleccionats',
    productCount_one: '{{count}} producte',
    productCount_other: '{{count}} productes',
    perUnit: 'per {{unit}}',
    colProduct: 'Producte',
    colSku: 'Referència',
    colCategory: 'Família',
    colUnit: 'Unitat',
    colStock: 'Estoc',
    colPrice: 'Preu',
    colQty: 'Quantitat',
    scanToView: 'Escaneja per veure el catàleg en línia',
    pdfOutdated: 'La informació dels productes ha canviat des del PDF generat el {{date}}.',
    saveDraft: 'Desar esborrany',
    saveChanges: 'Desar canvis',
    saveAndPublish: 'Desar i publicar',
    successSaved: 'Catàleg desat correctament.',
    successPublished: 'Catàleg publicat: ja està disponible al seu enllaç públic.',
    viewCatalogue: 'Veure catàleg',
    publicLink: 'Enllaç públic',
    slugChangeWarning: 'Si canvies l\'enllaç d\'un catàleg publicat, l\'anterior (i els QR impresos) deixarà de funcionar.',
    publicDraftHint: 'L\'enllaç només funcionarà quan publiquis el catàleg.',
    publicLiveHint: 'Qualsevol persona amb l\'enllaç pot veure aquest catàleg. Els preus de cost, els proveïdors i les notes internes no es mostren mai.',
    noEditPermission: 'No tens permís per modificar catàlegs.',
    qrTitle: 'Codi QR del catàleg',
    qrCode: 'Codi QR',
    copyLink: 'Copiar l\'enllaç',
    downloadQr: 'Descarregar QR',
    printQr: 'Imprimir QR',
    qrError: 'No s\'ha pogut descarregar el codi QR.',
    popupBlocked: 'El navegador ha bloquejat la finestra d\'impressió. Permet les finestres emergents i torna-ho a provar.',
    addToCatalogue: 'Afegir a catàleg',
    addToCatalogueBody_one: 'Tria un catàleg per afegir-hi aquest producte o crea\'n un de nou.',
    addToCatalogueBody_other: 'Tria un catàleg per afegir-hi {{count}} productes o crea\'n un de nou.',
    includedIn_one: 'Inclòs en {{count}} catàleg.',
    includedIn_other: 'Inclòs en {{count}} catàlegs.',
    included: 'Inclòs',
    add: 'Afegir',
    addedTo_one: '{{count}} producte afegit a «{{name}}».',
    addedTo_other: '{{count}} productes afegits a «{{name}}».',
    alreadyIn: 'Ja eren a «{{name}}».',
    createWithProducts_one: 'Nou catàleg amb aquest producte',
    createWithProducts_other: 'Nou catàleg amb {{count}} productes',
    publicNotFound: 'Catàleg no disponible',
    publicNotFoundBody: 'L\'enllaç no és vàlid o el catàleg ja no està publicat.',
    publicError: 'No s\'ha pogut carregar el catàleg',
    publicErrorBody: 'Comprova la connexió i torna-ho a provar.',
    publicEmpty: 'Aquest catàleg no té productes disponibles en aquest moment.',
    metaDescription: '{{name}}: catàleg amb {{count}} productes.',
    addToQuote: 'Afegir al pressupost',
    less: 'Menys',
    more: 'Més',
    quoteSummary_one: '{{count}} producte · {{units}} u.',
    quoteSummary_other: '{{count}} productes · {{units}} u.',
    requestQuote: 'Demanar pressupost',
    yourName: 'El teu nom o empresa (opcional)',
    sendByEmail: 'Correu',
    sendByWhatsapp: 'WhatsApp',
    clearQuote: 'Buidar la selecció',
    quoteSubject: 'Sol·licitud de pressupost — {{name}}',
    quoteIntro: 'Hola, m\'agradaria rebre un pressupost d\'aquests productes:',
    quoteIntroNamed: 'Hola, soc {{name}} i m\'agradaria rebre un pressupost d\'aquests productes:',
    // Quote requests (in-app)
    yourEmail: 'Correu electrònic',
    yourPhone: 'Telèfon',
    yourMessage: 'Missatge (opcional)',
    contactHint: 'Indica almenys un correu o un telèfon perquè et puguin respondre.',
    sendRequest: 'Enviar la sol·licitud',
    orSendBy: 'o envia-la tu mateix per',
    quoteSentTitle: 'Sol·licitud enviada',
    quoteSentBody: '{{company}} ha rebut la teva sol·licitud i et contactarà amb el pressupost.',
    backToCatalogue: 'Tornar al catàleg',
    quoteErr: {
      contact_required: 'Indica un correu o un telèfon.',
      email_invalid: 'El correu no és vàlid.',
      phone_invalid: 'El telèfon no és vàlid.',
      items_invalid: 'Els productes triats ja no estan disponibles. Recarrega la pàgina.',
      rate_limited: 'S\'han enviat massa sol·licituds. Torna-ho a provar d\'aquí a una estona.',
      quote_requests_off: 'Aquest catàleg no accepta sol·licituds de pressupost.',
      catalogue_not_available: 'Aquest catàleg ja no està disponible.',
      failed: 'No s\'ha pogut enviar la sol·licitud. Torna-ho a provar.',
    },
    tabCatalogues: 'Catàlegs',
    tabRequests: 'Sol·licituds',
    newRequests_one: '{{count}} sol·licitud de pressupost pendent',
    newRequests_other: '{{count}} sol·licituds de pressupost pendents',
    errLoadRequests: 'No s\'han pogut carregar les sol·licituds.',
    req_new: 'Pendents',
    req_done: 'Ateses',
    req_dismissed: 'Descartades',
    req_all: 'Totes',
    noRequestsTitle: 'No hi ha sol·licituds',
    noRequestsBody: 'Quan algú demani un pressupost des d\'un catàleg publicat, apareixerà aquí.',
    requestSummary_one: '{{count}} producte · {{units}} u.',
    requestSummary_other: '{{count}} productes · {{units}} u.',
    createEstimate: 'Crear pressupost',
    openEstimate: 'Obrir el pressupost',
    markDone: 'Marcar com a atesa',
    dismiss: 'Descartar',
    reopen: 'Tornar a obrir',
    estimateFromRequest: 'Sol·licitud del catàleg «{{catalogue}}».',
    err: {
      nameRequired: 'El nom del catàleg és obligatori.',
      nameTooLong: 'El nom no pot superar els 120 caràcters.',
      slugInvalid: 'L\'enllaç només admet minúscules, números i guions (3-80 caràcters).',
      slugTaken: 'Aquest enllaç ja el fa servir un altre catàleg. Tria\'n un altre.',
      duplicateProducts: 'Hi ha productes repetits al catàleg.',
      noProducts: 'Un catàleg necessita almenys un producte per publicar-se.',
      selectAtLeastOne: 'Selecciona almenys un producte per continuar.',
    },
  },
  perms: {
    mod_catalogue: 'Catàlegs de productes',
    'p_catalogue.view': 'Veure catàlegs',
    'p_catalogue.create': 'Crear catàlegs',
    'p_catalogue.edit': 'Editar catàlegs',
    'p_catalogue.delete': 'Eliminar catàlegs',
    'p_catalogue.publish': 'Publicar / despublicar catàlegs',
  },
};

const catalogueStrings = { es, en, ca };
export default catalogueStrings;
